import { mapState } from "vuex";
import Field from "@/components/loyalty/components/field/Index.vue";
import CampaignSection from "@/components/loyalty/entity/campaign/components/CampaignSection";
import { advancedParameters } from "@/components/loyalty/configs/sections/configAdvancedParameters";

export default {
  props: {
    section: Object,
  },

  components: {
    Field,
    CampaignSection,
  },

  computed: {
    ...mapState({
      allFields: state => state.loyalty.allFields,
      allSections: state => state.loyalty.allSections,
      info: state => state.loyalty.info,
      isEditMode: state => state.loyalty.isEditMode,
    }),

    fields() {
      if (this.hiddenFields) {
        const listHiddenFields = this.hiddenFields.flatMap(({ name }) => name);
        const listHiddenFieldsSet = new Set(listHiddenFields);
        return this.allFields.filter(field => this.generalConfig.find(i => i.name === field.name) && field.order)
          .filter(config => !listHiddenFieldsSet.has(config.name))
          .sort((a, b) => a.order - b.order);
      }

      if (this.priorityFields.length) {
        return this.generalConfig
          .map(field => {
            return {
              ...this.allFields.find(i => i.name === field.name),
              ...field,
            };
          })
          .sort((a, b) => a.order - b.order);
      }

      return this.allFields
        .filter(field => this.generalConfig.find(i => i.name === field.name) && field.order)
        .sort((a, b) => a.order - b.order);
    },

    showAdditionalOptions() {
      return this.$route.params &&
        Object.keys(advancedParameters).includes(this.$route.params.name) &&
        advancedParameters[this.$route.params.name] &&
        Object.keys(advancedParameters[this.$route.params.name]).includes(this.section.name);
    },

    priorityFields() {
      return this.generalConfig.filter(field => field.highPriority);
    },

    hiddenFields() {
      if (advancedParameters &&
        advancedParameters[this.$route.params.name] &&
        advancedParameters[this.$route.params.name][this.section.name]
      ) {
        return this.allFields
          .filter(field => advancedParameters[this.$route.params.name][this.section.name]
            .find(config => {
              if (config.name === field.name) {
                if (!config.shifting) {
                  if (config.column) field.column = config.column;
                  field.order = config.order;
                  return {...field};
                }
                if (config.shifting && config.shiftingValue === this.info.attributes[config.shifting] ||
                  config.shifting && config.shiftingValue === "shiftingValue"
                ) {
                  for (const key in config)
                    field[key] = config[key];
                  return {...field};
                }
                else {
                  const generalConfig = this.generalConfig.find(i => i.name === field.name);
                  for (const key in generalConfig)
                    field[key] = generalConfig[key];
                  return false;
                }
              }
              return false;
            }) && field.order)
          .sort((a, b) => a.order - b.order);
      }
      return;
    },

    allNames() {
      return this.fields.map(i => i.name);
    },
  },
};